import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-akaun-void-dialog",
  templateUrl: "./akaun-void-dialog.component.html",
  styleUrls: ["./akaun-void-dialog.component.scss"],
})
export class AkaunVoidDialogComponent {
  public docNo: string;
  public confirmMessage: string;
  public title: string;
  public enteredDocNo: string;
  public error: string;

  constructor(public dialogRef: MatDialogRef<AkaunVoidDialogComponent>) {
    if (!this.title) {
      this.title = "Warning!";
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  checkDocNo(): void {
    console.log("docNo", this.docNo)
    console.log("enteredDocno", this.enteredDocNo)
    if (this.enteredDocNo === this.docNo) {
      this.dialogRef.close(true);
    }else{
      this.error = "You have entered an incorrect doc no."
    }
  }
}
